<template>
  <div>
    <div v-if="fallback" class="fallback"></div>
    <iframe
      v-else
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      type="text/html"
      :src="url">
    </iframe>
  </div>
</template>

<script>
export default {
  props: ['videoId', 'extraprivacy'],
  data() {
    return {
      fallback: true,
      youtubeUrl: 'https://www.youtube-nocookie.com/embed/',
      options: '?fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0'
    }
  },
  computed: {
    url: function () {
      return this.youtubeUrl + this.videoId + this.options + '&origin=' + window.location.origin;
    }
  },
  mounted: function () {
    window.consent.subscribe('marketing').then(() => {
      this.fallback = false
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.fallback {
  width: 100%;
  padding-top: 56.25%;
  background-color: $grey;
}

iframe {
  position: absolute;
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/Youtube.vue